import { slicePrefix } from '../config'

const createValue = slicePrefix('fulfillment')

export const config = {
  /** Чат сообщества фулфилментов в Telegram. Вступление по заявке: заявки одобряют вручную. */
  communityChatUrl: 'https://t.me/+c9LpGV6wWbFjNDY6',
  modelName: createValue(),
} as const
